
{
  "familyId": "SPR-LEEN-FRANS",
  "questions": [
    {
      "id": "SPR-LEEN-FRANS-001",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["cadeau", "kado", "kadoo", "cadoo"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Franse leenwoorden", "content": "Franse leenwoorden behouden hun Franse spelling: cadeau (met -eau). Dit moet je uit je hoofd leren. Andere voorbeelden: bureau, niveau, plateau.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "loanword_spelling",
      "variantIndex": 1,
      "feedback": { "explanationText": "Dit is een Frans leenwoord en behoudt de Franse spelling: cadeau (met -eau). Je schrijft het niet zoals je het hoort (kado).", "distractorExplanations": { "0": "Correct! Franse leenwoorden behouden hun spelling: cadeau.", "1": "Fout: dit is de fonetische spelling. De juiste spelling is cadeau (Frans).", "2": "Fout: je schrijft het niet zoals je het hoort. De Franse spelling is cadeau.", "3": "Fout: de juiste Franse spelling is cadeau (met -eau, niet -oo)." } }
    }
  ]
}
